import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import "./style.scss";
import api from "../../utils/api";
import { canUseDOM } from "../../utils";

import PdpPage from "../../sections/pdp-page";
import PdpSummary from "../pdp-summary";
import PdpRefinePlan from "../../sections/pdp-refine-plan";
import Pdpfinancing from "../../sections/pdp-financing-plan";
import PdpOptionList from "../../react-components/pdp-option-list";
import AccountPreview from "../../react-components/account-preview";
import { canvas, scene } from "../../webgl/demo/";
import { comparisonString, toLowerCaseHyphenated } from "../../utils/siteUtils";
import { financingTab, orderTypes, PdpSubscribeType, PdpTowBarType, planType } from "../../utils/lynkco-constants";
import { selectUserState } from "../../selectors/application";
import { S_LANG, webStorage } from "../../utils/webStorage";
import { setPdpLccAction, setPdpPlanTypeAction, setPdpSummaryAction, setPdpLoanLeadsDataAction, setPdpLoanOrderStatusAction, setPdpMarketAction, setPdpBundleAction } from "../../redux/actions";
import { checkPdpStock, getStockLcc } from "../../services/pdpService";
import { multiBindConsents } from "../../services/consentService";
import { pdpLccSelector, pdpSummarySelector } from "../../selectors/pdp";
import { scrollToSmoothByPosition } from "../../hooks/scrollToSmooth.js";
import useQuery from "../../utils/useQuery";
import { appendQuery } from "../../utils/urlHelper";
import ImageBanner from "../../components/ImageBanner";
import { MathUtils } from "../../utils";
import { measurementNames } from "../../utils/measurements";

const PdpParentPage = ({ fields, match, productDataTable, bundleId, pdpPageProps, pdpPriceProps, loanBanner, refinePlanProps, servicePackageProps, financingProps, summaryProps, buyCarSummary, isMain = false, accountPreview, sceneData, onPlanChanged, isFetchingNewData }) => {
  const lang = webStorage.get(S_LANG);
  const query = useQuery();
  const relatedOrderNo = query?.relatedOrderNo;
  const carModelRef = useRef();
  const [planVisible, setPlanVisible] = useState(null);
  const [financingVisible, setFinancingVisible] = useState(null);
  const [servicePackageVisible, setServicePackageVisible] = useState(false);
  const [newPdpProps, setPdpProps] = useState(null);
  const [priceProps, setPriceProps] = useState(pdpPriceProps);
  const [summaryFeatures, setSummary] = useState([]);
  const [summarySections, setSummarySections] = useState(null);

  const [currentPlan, setCurrentPlan] = useState(null);
  const [oneTimePrice, setOneTimePrice] = useState(0);
  const [monthlyPrice, setMonthlyPrice] = useState(0);
  const [planChoices, setPlanChoices] = useState([]);

  const [newServicePackageProps, setServicePackageProps] = useState(servicePackageProps);
  const [servicePackageChoices, setServicePackageChoices] = useState([]);

  const [loanPrice, setLoanPrice] = useState(0);
  const [effectiveRateTag, setEffectiveRateTag] = useState(null);

  const [showLoginPanel, setShowLoginPanel] = useState(false);
  const [lastSummaryProps, setLastSummaryProps] = useState({});

  const [financingMethod, setFinancingMethod] = useState({});
  const [financingChoices, setFinancingChoices] = useState(null);
  const { checkoutButton } = refinePlanProps;

  const [currentColor, setCurrentColor] = useState(null);
  const [currentEngine, setCurrentEngine] = useState(null);
  const [currentModel, setCurrentModel] = useState(null);
  const [locationKeys, setLocationKeys] = useState([]);
  const [isFirstLoad, setFirstLoad] = useState(true);
  const [loanBannerAvaliable, setLoanBannerAvaliable] = useState(false);
  const [isIntersecting, setIsIntersecting] = useState(true);
  const [isOutOfStock, setIsOutOfStock] = useState(false);
  const { headingPercentage } = fields;
  /*Redux Start*/
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector(selectUserState);
  const pdpLcc = useSelector(pdpLccSelector);
  const pdpSummary = useSelector(pdpSummarySelector);
  const setPdpSummary = data => dispatch(setPdpSummaryAction(data));
  const setPdpLcc = data => dispatch(setPdpLccAction(data));
  const setPdpMarket = data => dispatch(setPdpMarketAction(data));
  const setPdpPlanType = data => dispatch(setPdpPlanTypeAction(data));
  const setPdpLoanLeadsData = data => dispatch(setPdpLoanLeadsDataAction(data));
  const setPdpBundle = data => dispatch(setPdpBundleAction(data));
  const setPdpLoanOrderStatus = payload => dispatch(setPdpLoanOrderStatusAction(payload));
  /*Redux End*/
  /** Global variables start*/
  let loanBannerHeight = canUseDOM() ? document.getElementsByClassName("loan-image-banner")[0]?.offsetHeight || 0 : 0;
  /** Global variables end*/

  useEffect(() => {
    setPdpProps(pdpPageProps);
    setFinancingVisible(false);
    getLcc();
    window.addEventListener("scroll", handleScroll, true);

    if (query && (query.show === "login" || query.show === "create-account") && !user) {
      setShowLoginPanel(true);
    }
    if (user) {
      removeLoginQuery();
    }

    if (isFirstLoad) {
      //** Measurements */
      let dataLayer = window.dataLayer || [];
      let parameters = match?.params?.service_options?.split("/");
      let membership = "";
      let color = "";
      let engineType = "";
      let towbar = "";
      let winterWheels = "";
      let storage = "";
      if (parameters) {
        membership = parameters.find(item => item.includes("month") || item.includes("buy"));
        color = parameters.find(item => item.includes("color"));
        engineType = parameters.find(item => item.includes("engine"));
        towbar = parameters.find(item => item.includes("towbar"));
        winterWheels = parameters.find(item => item.includes("winter"));
        storage = parameters.find(item => item.includes("storage"));
      }
      let details = {
        name: measurementNames.carName,
        id: "",
        price: "",
        brand: measurementNames.brandName,
        category: "car",
        variant: color ? color.split("-")[1] : "",
        engine: engineType ? engineType.split("-")[1] : "",
        membershipPlan: membership ? (membership.includes("month") ? "month-to-month" : "buy-car") : "",
        duration: "",
        mileage: "",
        winterWheels: winterWheels,
        downPayment: "",
        towbar: towbar ? towbar.split("-")[0] : "",
        storage: storage ? (storage.includes("no") ? "no" : "yes") : "",
        subscriptionValue: "",
        financingType: ""
      };

      dataLayer.push({
        event: "productDetail",
        products: [details]
      });
    }

    setFirstLoad(false);
  }, []);

  useEffect(() => {
    setPdpBundle(getDeliveryProduct());
  }, [productDataTable]);

  useEffect(() => {
    const newProps = { ...pdpPageProps };

    const masterPlan = [...planChoices, ...servicePackageChoices];
    const filterPlan = filterNoStockSelect(masterPlan);
    let { newOneTimePrice, newMonthlyPrice } = calculatePrice(filterPlan);
    let apr = "";
    let aprValue = headingPercentage?.value ? `${headingPercentage?.value} ${MathUtils.percentFormat(loanPrice?.period || 0)}` : null;

    let newOptionList = {
      ...newProps.optionList,
      isOutOfStock,
      userChoices: planChoices,
      options: newProps.optionList.options.map(option => ({
        ...option,
        enabled: true,
        buttons: option.buttons.map(btn => {
          let isSelected = masterPlan?.find(choice => choice.id === btn.id) ? true : false;
          if (btn?.hasOwnProperty("usableStock")) {
            isSelected = btn?.usableStock > 0 ? isSelected : false;
          }
          return {
            ...btn,
            isSelected: isSelected,
            className: option.buttons.length >= 3 ? "large" : ""
          };
        })
      })),
      acceptButton: getPdpContinueButton(),
      onPlanChanged: plan => {
        onPersonalizePlanClick(plan, false);
      }
    };

    // There are a few cycles during initialization when only the plan is available (before bundles are lloaded). We don't want to overwrite the route at that time.
    if (planChoices.length && newOptionList.options.length > 1) {
      newOptionList = mergeOptionPrices(planChoices, newOptionList);
    }
    newProps.optionList = newOptionList;
    if (loanPrice && loanBannerAvaliable && !isOutOfStock) {
      newOneTimePrice = "";
      newMonthlyPrice = loanPrice?.price || 0;
      apr = aprValue;
    }
    setPriceProps(prevProps => {
      return { ...prevProps, price: newMonthlyPrice, carPrice: newOneTimePrice, apr, effectiveRate: currentPlan?.planType === planType?.BaC && financingMethod?.id === "LOAN" ? effectiveRateTag : "" };
    });
    setPdpProps(newProps);
  }, [pdpPageProps, planChoices]);

  useEffect(() => {
    let newServiceProps = {
      ...servicePackageProps,
      userChoices: servicePackageChoices,
      options: (servicePackageProps?.options || []).map(option => ({
        ...option,
        enabled: true,
        buttons: (option.buttons || []).map(btn => {
          let isSelected = servicePackageChoices?.find(choice => choice.id === btn.id) ? true : false;
          if (btn?.hasOwnProperty("usableStock")) {
            isSelected = btn?.usableStock > 0 ? isSelected : false;
          }
          return {
            ...btn,
            isSelected: isSelected,
            className: option.buttons.length >= 3 ? "large" : ""
          };
        }),
        checkboxes: (option?.checkboxes || []).map(checkbox => {
          let isSelected = servicePackageChoices?.find(choice => choice.id === checkbox.id) ? true : false;

          return {
            ...checkbox,
            checked: isSelected
          };
        })
      }))
    };

    newServiceProps.userChoices = servicePackageChoices;

    if (newServiceProps?.acceptButton) {
      newServiceProps.acceptButton.callback = () => {
        visibleFinancing();
      };
    }

    setServicePackageProps(newServiceProps);
    const isSelectNoService = servicePackageChoices.find(option => option?.id === "no-service-plan");
    if (isSelectNoService && servicePackageChoices?.length === 1) {
      setFinancingVisible(false);
    }
    const masterPlan = [...planChoices, ...servicePackageChoices];
    const filterPlan = filterNoStockSelect(masterPlan);
    let { newOneTimePrice, newMonthlyPrice } = calculatePrice(filterPlan);
    let apr = "";
    let aprValue = headingPercentage?.value ? `${headingPercentage?.value} ${MathUtils.percentFormat(loanPrice?.period || 0)}` : null;

    if (loanPrice && loanBannerAvaliable && !isOutOfStock) {
      newOneTimePrice = "";
      newMonthlyPrice = loanPrice?.price || 0;
      apr = aprValue;
    }
    setPriceProps(prevProps => {
      return { ...prevProps, price: newMonthlyPrice, carPrice: newOneTimePrice, apr, effectiveRate: currentPlan?.planType === planType?.BaC && financingMethod?.id === "LOAN" ? effectiveRateTag : "" };
    });
  }, [servicePackageProps, servicePackageChoices]);

  useEffect(() => {
    if (planChoices.length <= 1) {
      const pdpChoicesFromRoute = [];
      const serviceChoicesFromRoute = [];

      // I'm using window.location here rather than match.url, since match.url won't have time to refresh before this effect is triggered.
      const routeChoiceIds = window?.location?.pathname?.split("/--/")[1]?.split("/") || [];

      (pdpPageProps?.optionList?.options || []).forEach(option => {
        (option.buttons || []).forEach(button => {
          if (routeChoiceIds.find(id => button.id === id)) {
            pdpChoicesFromRoute.push(button);
          }
        });
      });
      (servicePackageProps?.options || []).forEach(option => {
        (option.buttons || []).forEach(button => {
          if (routeChoiceIds.find(id => button.id === id)) {
            serviceChoicesFromRoute.push(button);
          }
        });
        (option.checkboxes || []).forEach(checkbox => {
          if (routeChoiceIds.find(id => checkbox.id === id)) {
            serviceChoicesFromRoute.push(checkbox);
          }
        });
      });

      onOptionSelected(pdpChoicesFromRoute, "configure", false); // False means we don't update route, since route determines choices and not other way around.
      onOptionSelected(serviceChoicesFromRoute, "service-package", false);
    }
  }, [match?.url, pdpPageProps]);

  useEffect(() => {
    return history.listen(location => {
      if (history.action === "PUSH") {
        setLocationKeys([location.key]);
      }
      if (history.action === "POP") {
        if (locationKeys[0] === location.key) {
          setLocationKeys(([_, ...keys]) => keys);
          setShowLoginPanel(window.location.href.includes("?show"));
        }
      }
    });
  }, [locationKeys, showLoginPanel]);

  useEffect(() => {
    if (showLoginPanel && !query?.show) {
      let newUrl = appendQuery(window.location.pathname, {
        show: "login"
      });
      window.history.pushState(null, null, newUrl);
    } else if (!showLoginPanel && query?.show && !isFirstLoad) {
      removeLoginQuery();
      document.body.style.overflow = "unset";
    }
  }, [showLoginPanel]);

  useEffect(() => {
    if (pdpLcc) {
      checkStock();
    }
  }, [planChoices, pdpLcc]);

  useEffect(() => {
    if (loanPrice && !isOutOfStock) {
      let aprValue = headingPercentage?.value ? `${headingPercentage?.value} ${MathUtils.percentFormat(loanPrice?.period || 0)}` : null;
      setPriceProps(prevProps => {
        return { ...prevProps, price: loanPrice?.price || "", carPrice: "", apr: aprValue, effectiveRate: effectiveRateTag };
      });
    }
  }, [loanPrice]);

  useEffect(() => {
    if (!isIntersecting) {
      setPriceProps(prevProps => {
        return { ...prevProps, size: "large" };
      });
    } else {
      setPriceProps(prevProps => {
        return { ...prevProps, size: "small" };
      });
    }
  }, [isIntersecting]);

  useEffect(() => {
    updateSelection();
  }, [planChoices, servicePackageChoices, financingChoices]);

  const filterNoStockSelect = (list = []) => {
    let newArr = list.filter(item => {
      let result = true;
      if (item?.hasOwnProperty("usableStock")) {
        result = item?.usableStock > 0;
      }
      return result;
    });
    return newArr;
  };
  const getPdpContinueButton = () => {
    if (currentPlan?.planType === planType.BaC) {
      return {
        ...pdpPageProps?.optionList?.acceptButton,
        callback: plan => {
          onPersonalizePlanClick(plan, true);
        }
      };
    } else if (currentPlan?.planType === planType.MtM) {
      setFinancingMethod({ description: "", id: financingTab.CASH, value: "Cash" });
      setFinancingVisible(false);
      setServicePackageVisible(false);

      return {
        ...financingProps.checkoutButton,
        link: { value: { ...financingProps?.checkoutButton?.link?.value, href: null, linktype: null } },
        callback: plan => {
          /** Measurement */
          measurements("addToCart", plan);
          let nextUrlNew = financingProps.checkoutButton?.link.value;
          if (!user) {
            measurements("checkout", plan);
            setShowLoginPanel(true);
          } else {
            updateSelection(nextUrlNew);
          }
        }
      };
    }

    return pdpPageProps?.optionList?.acceptButton;
  };

  const filterChoices = (plan, options) => {
    const dependencyTable = {};

    if (!options?.length) return plan;

    options.forEach(option => {
      (option.buttons || []).forEach(button => {
        dependencyTable[button.id] = option.prerequisites || [];
      });
      (option.checkboxes || []).forEach(checkbox => {
        dependencyTable[checkbox.id] = option.prerequisites || [];
      });
    });

    return plan.filter(choice => {
      if (!(choice.id in dependencyTable)) {
        // This effectively means that the choice does not exist in the list of choices.
        // It's a possible scenario when you change from month-to-month to buy-a-car, when the props change.
        return false;
      }
      const dependencies = dependencyTable[choice] || [];
      if (dependencies.length) {
        dependencies.forEach(dep => {
          if (!plan.find(item => item.id === dep)) {
            return false;
          }
        });
      }
      return true;
    });
  };

  //PEDRO-START: function to set route from the selected plans/options set by user
  const setRoute = plan => {
    let searchParams = "";

    let newUrl = `/${match.params.lang}/${match.params.sitecoreRoute}`;
    searchParams = `/--/${plan.map(item => toLowerCaseHyphenated(item.id)).join("/")}`;
    if (window.location.search) {
      searchParams += window.location.search;
    }
    if (window.location.hash) {
      searchParams += window.location.hash;
    }
    newUrl += searchParams;
    if (searchParams) {
      window.history.pushState(null, null, newUrl);
    }
  };
  //PEDRO-END

  /* Returns a list of products based on user choices */
  const getSelectedProducts = plan => {
    const products = new Set();

    if (productDataTable && plan) {
      for (const id in productDataTable) {
        if (plan.find(item => item.id === id)) {
          const item = productDataTable[id];
          const variant = getProductVariant(id, plan);

          const product = {
            spuId: item.spuId,
            skuId: variant?.skuId,
            price: variant?.price || item.lowestPrice,
            monthlyPrice: variant?.monthlyPrice || item.lowestMonthlyPrice
          };
          products.add(product);
        }
      }
    }

    return [...products];
  };

  /* Returns specific sku variant based on user choices */
  const getProductVariant = (id, plan) => {
    if (productDataTable && plan && id) {
      if (id in productDataTable) {
        const item = productDataTable[id];

        const variant = Object.keys(item.variants).find(keys => {
          const keyList = keys.split(",");
          return keyList.every(key => plan.find(choice => choice.id === key));
        });
        return item.variants[variant];
      }
    }
    return null;
  };

  /* Returns presentable data (such as price) for associated product variant (sku) based on button id. */
  const getItemPriceData = (id, plan) => {
    if (productDataTable && plan && id) {
      if (id in productDataTable) {
        // ID is a product and not a variant
        const item = productDataTable[id];
        const variant = Object.keys(item.variants).find(key => plan.find(item => item.id === key));
        return variant ? item.variants[variant] : { price: item.lowestPrice, monthlyPrice: item.lowestMonthlyPrice };
      } else {
        // ID is a variant of another product
        for (const [key, value] of Object.entries(productDataTable)) {
          if (id in Object.keys(value.variants) && plan.find(item => item.id === key)) {
            return value.variants[id];
          }
        }
      }
    }

    return { price: 0, monthlyPrice: 0 };
  };

  const getDeliveryProduct = () => {
    let delivery = {};
    if (productDataTable) {
      delivery = productDataTable["delivery"] || {};
    }
    return delivery;
  };

  /* Extracts prices based on product configuration, merges this into the PdpOptionList button props, and returns the new props. */
  const mergeOptionPrices = (plan, props) => {
    (props.options || []).forEach(option => {
      (option.buttons || []).forEach(button => {
        const itemPrice = getItemPriceData(button.id, plan);
        if (itemPrice) {
          Object.assign(button, itemPrice);
        }
      });
    });

    return props;
  };

  const onOptionSelected = (choices, section, updateRoute = true) => {
    const planItem = choices.find(item => item.parentLabel === "plan");
    const planTypeValue = (planChoices || []).find(item => item.parentLabel === "plan");
    let carePlanShow = planTypeValue?.carePlanShow;
    if (section === "configure") {
      const filteredChoices = filterChoices(choices, newPdpProps?.optionList?.options);

      if (planItem && planItem.id != currentPlan?.id) {
        setLastSummaryProps(planItem.summary || {});
        setPdpPlanType(planItem?.planType);
        setLoanPrice(0);
        setCurrentPlan(planItem);
        onPlanChanged && onPlanChanged(planItem);

        if (updateRoute) {
          // Clear choices when changing plan
          setRoute([planItem]);
          setServicePackageChoices([]);
          setPlanChoices([planItem]);
          setPriceProps(prevProps => {
            return { ...prevProps, isLoan: false };
          });
          return;
        }
      }

      setPlanChoices(filteredChoices);

      setCurrentColor(getSelectColor(filteredChoices));
      setCurrentEngine(getSelectEngine(filteredChoices));
      setCurrentModel(getSelectModel(filteredChoices));

      if (updateRoute) {
        setRoute([...filteredChoices, ...servicePackageChoices]);
      }
    } else if (section === "service-package" && carePlanShow) {
      const filteredChoices = filterChoices(choices, servicePackageProps?.options);
      (filteredChoices || []).forEach(item => {
        if (item.isCheckbox) {
          item.checked = true;
        }
      });
      setServicePackageChoices(filteredChoices);
      if (updateRoute) {
        setRoute([...planChoices, ...filteredChoices]);
      }
    }
  };

  const calculatePrice = plan => {
    let newMonthlyPrice = 0;
    let newOneTimePrice = 0;
    const products = getSelectedProducts(plan);
    products.forEach(product => {
      newMonthlyPrice += parseFloat(product.monthlyPrice || 0);
      newOneTimePrice += parseFloat(product.price || 0);
    });

    setOneTimePrice(newOneTimePrice);
    setMonthlyPrice(newMonthlyPrice);
    return { newOneTimePrice, newMonthlyPrice };
  };
  const visibleFinancing = () => {
    setFinancingVisible(true);
    setLoanBannerAvaliable(financingProps?.tabs?.defaultOption.id === financingTab.LOAN);
    setPriceProps(prevProps => {
      return { ...prevProps, isLoan: financingProps?.tabs?.defaultOption.id === financingTab.LOAN };
    });
  };
  const onPersonalizePlanClick = (plan, show) => {
    const isBuying = currentPlan?.planType === planType.BaC;
    let planValue = plan.filter(planItem => planItem.parentLabel === "plan")[0];
    let carePlanShow = planValue?.carePlanShow;
    let servicePackageVisibleNew = planValue?.carePlanShow;
    if (plan && show) {
      if (!isBuying) {
        visibleFinancing();
      } else {
        setFinancingMethod({ description: "", id: financingTab.LOAN, value: "Loan" });
      }
      if (!carePlanShow) {
        visibleFinancing();
      }
      setServicePackageVisible(servicePackageVisibleNew);
    }
  };

  const addButtonObserver = () => {
    try {
      if (carModelRef === null) {
        return;
      }

      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          setIsIntersecting(entry.isIntersecting);
        });
      });
      observer.observe(carModelRef.current);
      return () => {
        observer.unobserve(carModelRef.current);
      };
    } catch (error) {
      console.error(error);
    }
  };

  const handleScroll = () => {
    let position = document.getElementsByTagName("html")[0].scrollTop;
    let priceElem = document.getElementsByClassName("pdp-pricetag");
    let loanImageBanner = document.getElementsByClassName("loan-image-banner");
    let loanImageBannerHeight = document.getElementsByClassName("loan-image-banner")[0]?.offsetHeight;
    if (position > 0 && priceElem[0]) {
      priceElem[0].classList.add("scrolled");
      priceElem[0].style.top = "60px";

      if (loanImageBanner.length !== 0 && position > 0) {
        priceElem[0].classList.add("scrolled");
        priceElem[0].style.top = `${loanImageBannerHeight + 60}px`;
      }
    } else if (priceElem[0]) {
      priceElem[0] && priceElem[0].classList.remove("scrolled");
      priceElem[0].style.top = "";
    }
  };

  const onTabSelected = option => {
    let finance = document.getElementsByClassName("pdp-refine-plan grid")[0]?.offsetTop;
    let priceElem = document.getElementsByClassName("pdp-pricetag")[0]?.offsetHeight || 0;
    let loanWrapperHeight = document.getElementsByClassName("loan-image-banner")[0]?.offsetHeight || 0;
    let position = finance - priceElem - loanWrapperHeight - 60; //header size

    let aprValue = headingPercentage?.value ? `${headingPercentage?.value} ${MathUtils.percentFormat(loanPrice?.period || 0)}` : null;
    setFinancingMethod(option);
    if (comparisonString(option?.id, financingTab.LOAN)) {
      scrollToSmoothByPosition(position);
      setLoanBannerAvaliable(true);
      setLastSummaryProps(financingProps?.loanSummary);
      setPriceProps(prevProps => {
        return { ...prevProps, price: loanPrice?.price || 0, carPrice: "", apr: aprValue, isLoan: true, effectiveRate: effectiveRateTag };
      });
    } else {
      scrollToSmoothByPosition(position);
      setLoanBannerAvaliable(false);
      setLastSummaryProps(financingProps?.cashSummary);
      setPriceProps(prevProps => {
        return { ...prevProps, price: monthlyPrice || 0, carPrice: oneTimePrice || "", apr: "", isLoan: false, effectiveRate: "" };
      });
    }
  };
  const getServicePackageSkuId = () => {
    //about care plan,
    // 1.check sitcore carePlanShow value,
    // (1)when carePlanShow value is true,carePlanShow(servicePackage) display,Ignore detail api isRequired,only check spu.skuList.length===1
    // (2)when carePlanShow value is false,carePlanShow(servicePackage) no display,
    // (3)when carePlanShow value is false and  detail api isRequired === 1,add skuId in pdpSumary skuQtyVoList
    // (4)when carePlanShow value is false and  detail api isRequired === 0,no add skuId in pdpSumary skuQtyVoList
    let planValue = (planChoices || [])?.filter(planItem => planItem.parentLabel === "plan")[0];
    let carePlanShow = planValue?.carePlanShow;
    let servicePackageSkuId = null;
    let servicePackages = getSelectedProducts(servicePackageChoices);
    let servicePlanButton = servicePackageProps?.options.filter(option => option?.id === "service-package")[0]?.buttons.filter(btn => btn.id === "service-plan")[0];
    if (carePlanShow && servicePackages?.length && servicePackages[0].skuId) {
      servicePackageSkuId = servicePackages[0].skuId;
    }
    if (!carePlanShow && !servicePackages?.length && servicePlanButton) {
      servicePackages = getSelectedProducts([servicePlanButton]);
      if (servicePlanButton?.spuIsRequired === "1") {
        servicePackageSkuId = servicePackages[0]?.skuId;
      }
    }
    return servicePackageSkuId;
  };
  const updateSelection = (nextUrl, newFinancingChoices) => {
    let subType = "";

    const products = getSelectedProducts(planChoices);
    //const products = getSelectedProducts([...planChoices, ...servicePackageChoices]);
    const modelConfigCode = getProductVariant(currentPlan?.id, planChoices)?.extNo;
    const servicePackageSkuId = getServicePackageSkuId();
    let skuQtyVoList = products.map(product => ({ qty: "1", skuId: product.skuId }));
    const towbarState = planChoices.find(item => item.id === "yes-towbar") ? PdpTowBarType.yes : PdpTowBarType.no;
    const financing = newFinancingChoices || financingChoices;
    if (servicePackageSkuId) {
      skuQtyVoList.push({ qty: "1", skuId: servicePackageSkuId });
    }
    switch (currentPlan?.planType) {
      case planType.MtM:
        subType = orderTypes.monthToMonth;
        break;
      case planType.BaC:
        subType = orderTypes.buyACarLoan;
        if (financingTab.CASH === financing?.type) {
          subType = orderTypes.buyACarCash;
        }
        break;
    }

    const obj = {
      bundleId: bundleId,
      orderExtraData: {
        lccId: pdpLcc?.id,
        mccId: 0,
        touchPointId: 0,
        carDeliveryMethod: "",
        loanTotalAmount: oneTimePrice,
        loanMonthlyFee: financing?.monthlyPrice,
        loanDownPayment: financing?.downPayment,
        loanInterestRate: financing?.effectiveInterest,
        loanFinalpayment: financing?.finalPayment,
        loanPaymentMonthPeriod: financing?.period
      },
      skuQtyVoList: skuQtyVoList,
      subType: subType
    };
    setPdpLoanOrderStatus(null);
    setPdpSummary({
      apiBody: obj,
      SECCI: financing?.SECCI,
      engine: currentEngine,
      simulationId: financing?.simulationId,
      modelConfigCode: modelConfigCode,
      towbarState: towbarState,
      loanTermsAndConditions: financing?.loanTermsAndConditions,
      effectiveInterestLabel: effectiveRateTag
    });
    if (newFinancingChoices) {
      setPdpLoanLeadsData({
        engine: currentEngine,
        color: currentColor,
        loanProduct: financing?.loanProduct,
        downPayment: financing?.downPayment,
        duration: financing?.period,
        interestRate: financing?.effectiveInterest,
        mileage: null,
        montlyRate: financing?.monthlyPrice,
        marketing: lang
      });
    }
    setPdpMarket(lang);
    if (user && nextUrl) {
      let nextUrlNew = relatedOrderNo
        ? appendQuery(nextUrl?.href, {
            relatedOrderNo: relatedOrderNo
          })
        : nextUrl?.href;

      history.push(nextUrlNew);
    }
  };
  const getOutOfStockPrice = () => {
    const masterPlan = [...planChoices];
    const filterPlan = filterNoStockSelect(masterPlan);
    let { newOneTimePrice, newMonthlyPrice } = calculatePrice(filterPlan);
    let apr = "";
    setPriceProps(prevProps => {
      return { ...prevProps, price: newMonthlyPrice, carPrice: newOneTimePrice, apr, isOutOfStock: isOutOfStock };
    });
  };
  const getLcc = async () => {
    const data = await getStockLcc();
    setPdpLcc(data);
  };

  const checkStock = async () => {
    const { headingNoCaption, headingLessCaptionNumber, headingLessCaption, headingCaption } = fields;

    let captionText = headingCaption?.value;
    let isOutOfStockNew = false;
    const towbarState = planChoices.find(item => item.id === "yes-towbar") ? PdpTowBarType.yes : PdpTowBarType.no;
    const modelConfigCode = getProductVariant(currentPlan?.id, planChoices)?.extNo;

    const stocktype = currentPlan?.id === "buy-a-car" ? "0" : "1";
    if (stocktype && modelConfigCode && towbarState) {
      const stockCheckResponse = await checkPdpStock({ lccId: pdpLcc?.id, towbarState, modelConfigCode, stocktype });
      if (stockCheckResponse?.length && stockCheckResponse[0]?.availableQty > 0) {
        if (headingLessCaptionNumber?.value > stockCheckResponse[0]?.availableQty) {
          captionText = headingLessCaption?.value;
        }
      } else {
        captionText = headingNoCaption?.value;
        isOutOfStockNew = true;
        setServicePackageVisible(false);
        setFinancingVisible(false);
        setPlanVisible(false);
        getOutOfStockPrice();
      }
    }
    setIsOutOfStock(isOutOfStockNew);
    setPriceProps(prevProps => {
      return { ...prevProps, caption: captionText };
    });
    setPdpProps(prevProps => {
      return {
        ...prevProps,
        optionList: {
          ...prevProps?.optionList,
          isOutOfStock: isOutOfStockNew,
          notifyMeInfo: {
            ...prevProps?.optionList?.notifyMeInfo,
            modal: {
              ...prevProps?.optionList?.notifyMeInfo?.modal,
              callback: (evt, formData) => {
                noStockSubmit(formData);
              }
            }
          }
        }
      };
    });
  };

  const noStockSubmit = async formData => {
    let subscribeType = "";

    const productInfo = getProductVariant(currentPlan?.id, planChoices);

    switch (currentPlan?.planType) {
      case planType.BaC:
        subscribeType = PdpSubscribeType?.buyACar;
        break;
      case planType.MtM:
        subscribeType = PdpSubscribeType?.monthToMonth;
        break;
    }

    if (formData?.email) {
      try {
        await multiBindConsents(formData?.email, formData?.country, formData?.consentNos);
        await api.user.vehicle.stock.subscribe(null, {
          noticeType: formData?.noticeType,
          skuId: productInfo?.skuId,
          modelConfigCode: productInfo?.extNo,
          email: formData?.email,
          mobile: formData?.mobileNo,
          mobileCountryCode: formData?.mobileCountryCode,
          subscribeType: subscribeType,
          warehouseOrgId: pdpLcc?.lccId
        });
        setPdpProps(prevProps => {
          return {
            ...prevProps,
            optionList: {
              ...prevProps?.optionList,
              notifyMeInfo: {
                ...prevProps?.optionList?.notifyMeInfo,
                modal: {
                  ...prevProps?.optionList?.notifyMeInfo?.modal,
                  notifyError: false,
                  notifySuccess: true
                }
              }
            }
          };
        });
      } catch (e) {
        setPdpProps(prevProps => {
          return {
            ...prevProps,
            optionList: {
              ...prevProps?.optionList,
              notifyMeInfo: {
                ...prevProps?.optionList?.notifyMeInfo,
                modal: {
                  ...prevProps?.optionList?.notifyMeInfo?.modal,
                  notifyError: true,
                  notifySuccess: false
                }
              }
            }
          };
        });
      }
    }
  };

  const getSelectColor = data => {
    let colors = data.filter(x => x.skuAttrDefaultLabel?.toLowerCase() === "color");
    if (colors && colors.length) {
      return colors[0].skuAttrDefaultValue;
    }
    return null;
  };
  const getSelectEngine = data => {
    let engines = data.filter(x => x.skuAttrDefaultLabel?.toLowerCase() === "engine");
    if (engines && engines.length) {
      return engines[0].skuAttrDefaultValue;
    }
    return null;
  };
  const getSelectModel = data => {
    let engines = data.filter(x => x.skuAttrDefaultLabel?.toLowerCase() === "engine");
    if (engines && engines.length) {
      return engines[0].model;
    }
    return null;
  };

  const removeLoginQuery = () => {
    if (query && query?.show && query.relatedOrderNo) {
      let newUrl = appendQuery(window.location.pathname, {
        relatedOrderNo: query.relatedOrderNo
      });
      window.history.pushState(null, null, newUrl);
    } else if (query && query?.show) {
      window.history.pushState(null, null, window.location.pathname);
    }
  };

  const loanCashPriceChange = (price, effectiveInterest, priceTag) => {
    setEffectiveRateTag(priceTag);
    setLoanPrice({ price: price, period: effectiveInterest });
  };

  const measurements = (type, plan, loanChoices) => {
    let dataLayer = window.dataLayer || [];

    const membership = plan.find(item => item?.id?.includes("month") || item?.id?.includes("buy"));
    const color = plan.find(item => item?.id?.includes("color"));
    const engineType = plan.find(item => item?.id?.includes("engine"));
    const towbar = plan.find(item => item?.id?.includes("towbar"));
    const winterWheels = plan.find(item => item?.id?.includes("winter"));
    const storage = plan.find(item => item?.id?.includes("storage"));
    const mileage = plan.find(item => item?.id?.includes("mileage"));

    let checkoutFlow = membership?.id;
    let financingType = "";
    if (membership?.id !== "month-to-month") {
      if (financingMethod && financingMethod.id === "LOAN") {
        financingType = "loan";
        checkoutFlow = "buy-car-loan";
      } else {
        financingType = "cash";
        checkoutFlow = "buy-car-cash";
      }
    }

    let details = {
      name: measurementNames.carName,
      id: bundleId,
      price: oneTimePrice,
      brand: measurementNames.brandName,
      category: "car",
      variant: color?.id ? color?.id.split("-")[1] : "",
      engine: engineType?.id ? engineType?.id.split("-")[1] : "",
      membershipPlan: checkoutFlow,
      duration: loanChoices ? loanChoices.period : "",
      mileage: mileage ? mileage.valueText : "",
      winterWheels: winterWheels ? winterWheels.id : "",
      downPayment: financingType === "cash" ? "" : loanChoices ? loanChoices.downPayment : "",
      towbar: towbar ? (towbar.id.includes("no") ? "no" : "yes") : "",
      storage: storage ? (storage.id.includes("no") ? "no" : "yes") : "",
      financingType: financingType,
      subscriptionValue: monthlyPrice
    };

    switch (type) {
      case "addToCart":
        dataLayer.push({
          event: "addToCart",
          products: [details]
        });
        break;
      case "checkout":
        dataLayer.push({
          event: "checkout",
          step: 1,
          checkoutFlow: checkoutFlow,
          products: [details]
        });
        break;
    }
  };

  const pdpProps = {
    ...newPdpProps,
    ref: carModelRef,
    fields: fields,
    onSelectCallback: plan => onOptionSelected(plan, "configure"),
    onRefLoaded: () => addButtonObserver(),
    canvas: canvas,
    scene: scene,
    sceneData: sceneData,
    isFetchingNewData: isFetchingNewData,
    price: priceProps,
    loanBannerHeight: loanBannerHeight,
    showFootnote: loanBannerAvaliable && financingVisible && financingMethod && financingMethod.id === "LOAN" && currentPlan && currentPlan.planType === planType.BaC
  };
  return (
    <>
      {loanBannerAvaliable && loanBanner && financingVisible && (
        <div className="loan-image-banner">
          <ImageBanner fields={loanBanner.fields} />
        </div>
      )}
      <div
        className={classNames("pdp-page-container", {
          main: isMain,
          disabled: showLoginPanel
        })}
      >
        {newPdpProps && <PdpPage {...pdpProps} currentPlan={currentPlan?.id} />}
        {newServicePackageProps?.options?.length > 0 && servicePackageVisible && (
          <PdpOptionList
            {...{
              ...newServicePackageProps,

              onSelectCallback: plan => onOptionSelected(plan, "service-package")
            }}
            scrollOffset={() => canvas.height}
            isServicePackage={true}
          />
        )}
        {planVisible && refinePlanProps && (
          <>
            <PdpRefinePlan
              {...{
                ...refinePlanProps,
                onTabSelected: onTabSelected,
                onCheckout: (plan, index, type, nextUrl) => {
                  if (!user && type === "submit") {
                    setShowLoginPanel(true);
                  }
                  updateSelection(nextUrl);
                },
                onOptionSelected: (plan, index) => {}
              }}
            />
            <PdpSummary
              {...{
                ...lastSummaryProps,
                features: summaryFeatures,
                summarySections: summarySections
              }}
            />
          </>
        )}
        {financingVisible && financingProps && currentColor && currentEngine && oneTimePrice && (
          <Pdpfinancing
            {...{
              ...financingProps,
              lang,
              ...{
                vehicleProps: {
                  color: currentColor,
                  engine: currentEngine,
                  model: currentModel,
                  retailPrice: oneTimePrice
                }
              },
              onTabSelected: onTabSelected,
              summarySections: summarySections,
              onCheckout: (plan, index, type, nextUrl, loanChoices) => {
                measurements("addToCart", planChoices, loanChoices);
                setFinancingChoices(loanChoices);
                if (!user && type === "submit") {
                  measurements("checkout", planChoices, loanChoices);
                  setShowLoginPanel(true);
                }
                updateSelection(nextUrl, loanChoices);
              },
              onOptionSelected: (plan, index) => {
                // setRoute(plan);
              },
              changeValueCallback: loanCashPriceChange
            }}
          />
        )}
      </div>

      {!user && showLoginPanel && (
        <div className="pdp-container">
          <AccountPreview
            {...{
              ...accountPreview,
              active: showLoginPanel,
              onClickOutside: () => setShowLoginPanel(false),
              onItemClick: () => setShowLoginPanel(false),
              onAccountLogin() {
                setShowLoginPanel(false);
                let nextUrlNew = relatedOrderNo
                  ? appendQuery(checkoutButton?.link?.value?.href, {
                      relatedOrderNo: relatedOrderNo
                    })
                  : checkoutButton?.link?.value?.href;
                history.push(nextUrlNew);
              }
            }}
          />
        </div>
      )}
    </>
  );
};
export default PdpParentPage;
